var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"rules":[_vm.rules.validate]},on:{"input":function($event){return _vm.onSelect()}},model:{value:(_vm.selectedValue),callback:function ($$v) {_vm.selectedValue=$$v},expression:"selectedValue"}},[_c('template',{slot:"label"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t('labels.Email'))}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }